import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { DistinctValue } from "../../../types";
import { EntityFieldItem } from "../../../services/cleaning-data-service";
import FieldAutocomplete from "../../shared/field-autocomplete";
import useMoveValues from "./hooks/use-move-values";

interface MoveValuesFooterProps {
  fieldId: number | undefined;
  checked: { [key: string]: boolean };
  mainValues: DistinctValue[];
  selectedItem: DistinctValue | null;
  refreshDistinctValues: () => void;
  availableFields: EntityFieldItem[] | undefined;
  isLoadingFields: boolean;
}

/**
 * Footer for Move Values category (categoryId: 6)
 */
const MoveValuesFooter: React.FC<MoveValuesFooterProps> = ({
  fieldId,
  checked,
  mainValues,
  selectedItem,
  refreshDistinctValues,
  availableFields,
  isLoadingFields,
}) => {
  const {
    selectedTargetField,
    targetFieldOptions,
    message,
    setSelectedTargetField,
    handleMove,
  } = useMoveValues({
    fieldId,
    checked,
    mainValues,
    selectedItem,
    refreshDistinctValues,
    availableFields,
  });

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderTop: "1px solid #eee",
          p: 2,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {message}
        </Typography>
        <FieldAutocomplete
          options={targetFieldOptions || []}
          value={selectedTargetField}
          onFieldChange={setSelectedTargetField}
          disabled={
            isLoadingFields ||
            !targetFieldOptions ||
            targetFieldOptions.length === 0
          }
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          borderTop: "1px solid #eee",
          p: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mr: 1, borderRadius: 1 }}
          onClick={handleMove}
          disabled={
            !selectedTargetField ||
            !targetFieldOptions ||
            targetFieldOptions.length === 0
          }
        >
          Move
        </Button>
      </Box>
    </Box>
  );
};

export default MoveValuesFooter;
